export enum PermissionTab {
  WEB = 'WEB',
  APP = 'APP',
}
